import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Badge,
    Button,
    Collapse,
    InputGroup,
    ListGroup,
    ListGroupItem,
} from 'reactstrap';
import { fetchFrontOptions } from '../actions/previewSideBar';
import { ColorRow } from './rows/colorRow';
import { InputRow } from './rows/InputRow';
import { RadioRow } from './rows/RadioRow';
import _ from 'underscore';

function parseProps(props) {
    return {
        option_name: props.options.option_name,
        action_type: props.options.action_type,
        settings_old: {
            ...props.options.settings,
        },
        settings: {
            ...props.options.settings,
        },

        condition: {},
    };
}

class SettingOptionsModal extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.confirmAction = this.confirmAction.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.onResetSettings = this.onResetSettings.bind(this);
        this.onChangeSettingsByNameValue =
            this.onChangeSettingsByNameValue.bind(this);
        this.onChangeSettingsColor = this.onChangeSettingsColor.bind(this);
        this.onToggleBoolean = this.onToggleBoolean.bind(this);
    }

    confirmAction() {
        const props = this.props,
            state = this.state,
            { dispatch } = props;
        dispatch(
            fetchFrontOptions({
                name: state.option_name,
                data: state.settings,
            })
        );
    }

    onResetSettings() {
        this.setState({
            settings: {
                ...this.state.settings_old,
            },
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!Object.equals(this.state.settings, prevState.settings)) {
            const props = this.props,
                { dispatch } = props;
            dispatch({
                type: this.state.action_type,
                data: {
                    ...this.state.settings,
                },
            });
        }
    }

    static arrayLinesTransformFromArray(lists_example, group, lines, settings) {
        const property_name = group.property_name,
            settings_from_property =
                SettingOptionsModal.getObjectValueFromStringLink(
                    property_name,
                    settings
                );
        let list = _.map(lines, (i) => i),
            key_add = -1;

        _.each(settings_from_property, (property, array_key) => {
            _.each(lists_example, (example) => {
                let new_line_property_name =
                    property_name +
                    '[' +
                    array_key +
                    ']' +
                    example.property_name;
                if (example.type === 'array' && example.lines) {
                    list = SettingOptionsModal.arrayLinesTransformFromArray(
                        example.lines,
                        {
                            ...example,
                            property_name: new_line_property_name,
                        },
                        list,
                        settings
                    );
                } else {
                    list.push({
                        ...example,
                        property_name: new_line_property_name,
                    });
                }
            });

            if (parseInt(array_key) > key_add) key_add = parseInt(array_key);

            if (group.remove_button) {
                list.push({
                    name: group.remove_button,
                    property_name: property_name + '[' + array_key + ']',
                    type: 'remove_array',
                });
            }
        });
        if (group.add_button) {
            key_add = key_add + 1;
            list.push({
                name: group.add_button,
                property_name: property_name + '[' + key_add + ']',
                type: 'add_array',
            });
        }
        return list;
    }

    static getObjectValueFromStringLink(property_name, settings) {
        const property_name_split = _.filter(
            String(property_name).split(/[.\[\]]/),
            (i) => i !== ''
        );
        let find;
        if (property_name_split.length > 1) {
            let setting_iteration = settings;
            _.each(property_name_split, (name_key, key, arr) => {
                let setting_find = setting_iteration[name_key];

                if (setting_find === undefined && key !== arr.length - 1) {
                    setting_find = {};
                }

                if (key === arr.length - 1) {
                    find = setting_find;
                    return;
                }
                setting_iteration = setting_find;
            });
            return find;
        } else {
            return settings[property_name];
        }
    }

    modalLine(content) {
        return <div className="modal-line mt-4">{content}</div>;
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({ ...state });
    }

    onChangeSettingsByNameValue(name, value) {
        let settings = { ...this.state.settings };
        const name_arr = _.filter(
            String(name).split(/[.\[\]]/),
            (i) => i !== ''
        );
        if (name_arr.length === 1) {
            settings = {
                ...settings,
                [name]: value,
            };
        } else {
            let setting_iteration = settings,
                list_setting = [];

            _.find(name_arr, (name_key, key, arr) => {
                let setting_find = (setting_iteration || {})[name_key];
                if (key === arr.length - 2) {
                    if (value === undefined) {
                        setting_find = { ...setting_find };
                        delete setting_find[arr[key + 1]];
                        // delete setting_find[String(arr[key + 1])];
                    } else {
                        setting_find = {
                            ...setting_find,
                            [arr[key + 1]]: value,
                        };
                    }
                }
                setting_iteration = setting_find;
                list_setting.push({
                    key: name_key,
                    data: setting_iteration,
                });
                return key === arr.length - 2;
            });
            let reduce_setting = _.reduceRight(list_setting, (a, b) => {
                return {
                    ...b,
                    data: {
                        ...b.data,
                        [a.key]: a.data,
                    },
                };
            });

            settings = {
                ...settings,
                [reduce_setting.key]: {
                    ...reduce_setting.data,
                },
            };
        }
        this.setState({
            settings: {
                ...settings,
            },
        });
    }

    onChangeSettingsColor(color, name, condition_name_is_rgba) {
        const is_rgba = this.state.condition[condition_name_is_rgba] || false,
            rgb = color.rgb,
            color_css =
                (is_rgba ? 'rgba' : 'rgb') +
                '(' +
                rgb.r +
                ',' +
                rgb.g +
                ',' +
                rgb.b +
                (is_rgba ? ',' + rgb.a : '') +
                ')';
        this.onChangeSettingsByNameValue(name, color_css);
    }

    onToggleBoolean(name, hardBool) {
        let condition = { ...this.state.condition };
        condition[name] =
            hardBool === 'true' || hardBool === 'false'
                ? hardBool === 'true'
                : !this.state.condition[name];
        this.setState({
            condition: condition,
        });
    }

    render() {
        const props = this.props,
            state = this.state,
            // isFetching = props.isFetching,
            // isInvalid = props.didInvalidate,
            settings = state.settings;
        return (
            <div>
                <div className="modal-scroll shop-case">
                    {!props.options.components
                        ? null
                        : props.options.components}
                    {_.map(props.options.groups, (group, key_group) => {
                        let name_open = key_group + '_show',
                            lines = group.lines;

                        if (group.type === 'array') {
                            lines =
                                SettingOptionsModal.arrayLinesTransformFromArray(
                                    group.lines,
                                    group,
                                    [],
                                    settings
                                );
                        }

                        lines = _.map(lines, (l, k) => {
                            if (l.type === 'array') {
                                l = {
                                    type: 'array',
                                    lines: SettingOptionsModal.arrayLinesTransformFromArray(
                                        l.lines,
                                        l,
                                        [],
                                        settings
                                    ),
                                };
                            }
                            return l;
                        });
                        lines = _.reduce(
                            lines,
                            (arr, line) => {
                                if (line.type === 'array') {
                                    _.each(line.lines, (l) => arr.push(l));
                                } else {
                                    arr.push(line);
                                }
                                return arr;
                            },
                            []
                        );
                        return (
                            <ListGroup key={key_group}>
                                <ListGroupItem
                                    className={'text-left'}
                                    tag="button"
                                    onClick={() =>
                                        this.onToggleBoolean(name_open)
                                    }
                                >
                                    <div>
                                        {!group.badge ? null : (
                                            <Badge pill className="mr-3">
                                                {group.badge}
                                            </Badge>
                                        )}
                                        {group.header}
                                    </div>
                                </ListGroupItem>
                                <ListGroupItem
                                    className={
                                        !state.condition[name_open]
                                            ? 'd-none'
                                            : ''
                                    }
                                >
                                    <Collapse
                                        isOpen={!!state.condition[name_open]}
                                    >
                                        {group.type === 'custom'
                                            ? group.content
                                            : !state.condition[name_open]
                                            ? null
                                            : _.map(lines, (line, key_line) => {
                                                  let property_name =
                                                          line.property_name,
                                                      setting_val =
                                                          SettingOptionsModal.getObjectValueFromStringLink(
                                                              property_name,
                                                              settings
                                                          );

                                                  return (
                                                      <div
                                                          key={key_line}
                                                          className={
                                                              'p-2 d-inline-block w-' +
                                                              (line.width ||
                                                                  100)
                                                          }
                                                      >
                                                          <div>
                                                              <div className="w-100">
                                                                  {line.header}
                                                              </div>
                                                              {line.type !==
                                                                  'color' &&
                                                              line.type !==
                                                                  'textarea' &&
                                                              line.type !==
                                                                  'input' &&
                                                              line.type !==
                                                                  'radio' &&
                                                              line.type !==
                                                                  'select' ? (
                                                                  line.type ===
                                                                  'add_array' ? (
                                                                      <Button
                                                                          className={
                                                                              'mt-3'
                                                                          }
                                                                          color="success"
                                                                          onClick={() =>
                                                                              this.onChangeSettingsByNameValue(
                                                                                  line.property_name,
                                                                                  {}
                                                                              )
                                                                          }
                                                                      >
                                                                          {
                                                                              line.name
                                                                          }
                                                                      </Button>
                                                                  ) : line.type !==
                                                                    'remove_array' ? null : (
                                                                      <Button
                                                                          color="danger"
                                                                          onClick={() =>
                                                                              this.onChangeSettingsByNameValue(
                                                                                  line.property_name
                                                                              )
                                                                          }
                                                                      >
                                                                          {
                                                                              line.name
                                                                          }
                                                                      </Button>
                                                                  )
                                                              ) : (
                                                                  <InputGroup className="w-100">
                                                                      {line.type ===
                                                                      'color' ? (
                                                                          <ColorRow
                                                                              line={
                                                                                  line
                                                                              }
                                                                              value={
                                                                                  setting_val
                                                                              }
                                                                              onChangeSettingsByNameValue={
                                                                                  this
                                                                                      .onChangeSettingsByNameValue
                                                                              }
                                                                          />
                                                                      ) : line.type ===
                                                                            'textarea' ||
                                                                        line.type ===
                                                                            'input' ? (
                                                                          <InputRow
                                                                              rows={
                                                                                  10
                                                                              }
                                                                              line={
                                                                                  line
                                                                              }
                                                                              value={
                                                                                  setting_val
                                                                              }
                                                                              onChangeSettingsByNameValue={
                                                                                  this
                                                                                      .onChangeSettingsByNameValue
                                                                              }
                                                                          />
                                                                      ) : line.type ===
                                                                        'radio' ? (
                                                                          <RadioRow
                                                                              line={
                                                                                  line
                                                                              }
                                                                              value={
                                                                                  setting_val
                                                                              }
                                                                              onChangeSettingsByNameValue={
                                                                                  this
                                                                                      .onChangeSettingsByNameValue
                                                                              }
                                                                          />
                                                                      ) : line.type ===
                                                                        'select' ? (
                                                                          <InputRow
                                                                              line={
                                                                                  line
                                                                              }
                                                                              multiple={
                                                                                  !!line.multiple
                                                                              }
                                                                              value={
                                                                                  setting_val
                                                                              }
                                                                              onChangeSettingsByNameValue={
                                                                                  this
                                                                                      .onChangeSettingsByNameValue
                                                                              }
                                                                          >
                                                                              {!line.default_value ? null : (
                                                                                  <option
                                                                                      {...line.default_value}
                                                                                  >
                                                                                      {
                                                                                          line
                                                                                              .default_value
                                                                                              .name
                                                                                      }
                                                                                  </option>
                                                                              )}
                                                                              {_.map(
                                                                                  line.values,
                                                                                  (
                                                                                      value,
                                                                                      key
                                                                                  ) => {
                                                                                      return (
                                                                                          <option
                                                                                              key={
                                                                                                  key
                                                                                              }
                                                                                              value={
                                                                                                  value.value
                                                                                              }
                                                                                          >
                                                                                              {
                                                                                                  value.name
                                                                                              }
                                                                                          </option>
                                                                                      );
                                                                                  }
                                                                              )}
                                                                          </InputRow>
                                                                      ) : (
                                                                          ''
                                                                      )}
                                                                  </InputGroup>
                                                              )}
                                                          </div>
                                                      </div>
                                                  );
                                              })}
                                    </Collapse>
                                </ListGroupItem>
                            </ListGroup>
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <div
                        className="btn btn-success pointer-no-select"
                        onClick={this.confirmAction}
                    >
                        Сохранить
                    </div>
                    <div
                        className="pull-right btn btn-warning pointer-no-select"
                        onClick={this.onResetSettings}
                    >
                        Сбросить
                    </div>
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {};
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
};

export const SettingOptionsModalContainer = connect(
    MapStateToProps,
    mapDispatchToProps
)(SettingOptionsModal);
